// Maps a 0..1 similarity score from `suggestMatches` to a label + colour
// variant the UI uses for the AI badge in row cells. Mirrors the legacy
// colour ramp from `components/page/hyper-guest/components/ProductHotelMatcherTable`.
export type AiScoreVariant = 'strong' | 'good' | 'possible' | 'low';

export type AiScore = {
  variant: AiScoreVariant;
  label: string;
  percent: number;
};

export const scoreToLabel = (similarity: number): AiScore => {
  const pct = Math.round(Math.max(0, Math.min(1, similarity)) * 100);
  if (pct >= 80)
    return { variant: 'strong', label: 'Strong match', percent: pct };
  if (pct >= 60) return { variant: 'good', label: 'Good match', percent: pct };
  if (pct >= 40)
    return { variant: 'possible', label: 'Possible match', percent: pct };
  return { variant: 'low', label: 'Low match', percent: pct };
};
